/**
 * Version Utility Functions
 * Handles API calls and data transformations for Versions
 */

function payloadVersion(data) {
    let payload = {};
    payload.name = data.name;
    payload.type = data.type;
    payload.description = data.description;
    return payload;
}

function dataVersion(data) {
    return data;
}

export const getVersion = (dsd, id, onLoad, onFail) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    dsd.httpConfig.get(`/versions/${id}`, headers)
        .then(response => {
            if (onLoad) {
                onLoad(dataVersion(response.data));
            }
        })
        .catch(e => {
            if (onFail) {
                onFail(e);
            }
            console.error('Failed to get version:', e);
        });
};

export const listVersions = (dsd, Filters = {}, onLoad, onError) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let urlAPI = "/versions";
    if (Object.keys(Filters).length > 0) {
        urlAPI += "?";
    }

    if (Filters.idUser) {
        urlAPI += `idUser=${encodeURIComponent(Filters.idUser)}&`;
    }

    if (Filters.idAbout) {
        urlAPI += `idAbout=${encodeURIComponent(Filters.idAbout)}&`;
    }

    dsd.httpConfig.get(urlAPI, headers)
        .then(response => {
            let arr = [];
            for (let pos = 0; pos < response.data.length; pos++) {
                arr.push(dataVersion(response.data[pos]));
            }
            if (onLoad) {
                onLoad(arr);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.error('Failed to list versions:', e);
        });
};

export const addVersion = (dsd, idAbout, Data = {}, onSuccess, onError) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    Data.idAbout = idAbout;
    let payload = payloadVersion(Data);
    payload.idAbout = idAbout;

    dsd.httpConfig.post(`/versions`, payload, headers)
        .then(response => {
            if (onSuccess) {
                onSuccess(response.data._id);
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.error('Failed to add version:', e);
        });
};

export const editVersion = (dsd, id, Data = {}, onSuccess, onError) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    let payload = payloadVersion(Data);

    dsd.httpConfig.put(`/versions/${id}`, payload, headers)
        .then(response => {
            if (onSuccess) {
                onSuccess();
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.error('Failed to edit version:', e);
        });
};

export const deleteVersion = (dsd, id, onSuccess, onError) => {
    let headers = {
        headers: {
            "Content-type": "application/json"
        }
    };

    let authHeader = dsd.authHeader();
    if (authHeader) {
        headers.headers.Authorization = authHeader.Authorization;
    }

    dsd.httpConfig.delete(`/versions/${id}`, headers)
        .then(response => {
            if (onSuccess) {
                onSuccess();
            }
        })
        .catch(e => {
            if (onError) {
                onError(e);
            }
            console.error('Failed to delete version:', e);
        });
};
